import { Component, computed, input, output } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgClickOutsideDirective } from "ng-click-outside2";

@Component({
  selector: "modify-l2vpn-fw-button",
  templateUrl: "modify-l2vpn-fw-button.html",
  imports: [AngularSvgIconModule, MatTooltipModule, NgClickOutsideDirective, TranslateModule],
})
export class ModifyL2vpnFwButton {
  readonly subscription = input.required<{ product: { tag: string }; dirty: boolean }>();
  readonly isInfrastructureDelegate = input.required<boolean>();

  protected clicked = output<string>();

  protected selfServiceEnabled = computed(() => !this.subscription().dirty);

  protected overflowMenuActive = false;

  protected selectItem = (item: string) => this.clicked.emit(item);
}
